// Sticky transition-action bar for the russia-requests drawer (#944).
// Mirror of `RequestDrawerStickyActionBar` (china): pure-presentational,
// renders one button per allowed transition. The parent owns the
// `onAction` routing (confirm modal vs. reason modal vs. fire) so this
// component stays simple.

import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/index.js';
import type { RussiaTransitionAction } from '../role.js';

export function RussiaRequestDrawerStickyActionBar({
  actions,
  onAction,
  pending = false,
}: {
  actions: RussiaTransitionAction[];
  onAction: (a: RussiaTransitionAction) => void;
  // WHY (#944): while the transition mutation is in flight, every action
  //   button must disable so a fast double-click does not POST twice
  //   before the row's optimistic state settles. The parent owns the
  //   mutation lifecycle (`useTransitionRussiaRequest`) and forwards its
  //   `isPending` flag here.
  pending?: boolean;
}) {
  const { t } = useTranslation('russiaRequests');
  if (actions.length === 0) return null;
  return (
    <div
      data-testid="russia-request-drawer-sticky-bar"
      style={{
        flex: 'none',
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
        background: 'var(--bg-1)',
        borderTop: '1px solid var(--border-1)',
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      {actions.map((a) => (
        <Button
          key={a.key}
          kind={a.kind}
          icon={a.icon}
          disabled={pending}
          data-testid={`russia-request-drawer-action-${a.key}`}
          onClick={() => onAction(a)}
        >
          {t(a.labelKey)}
        </Button>
      ))}
    </div>
  );
}
